import DatabaseModel from './DatabaseModel.js';

var Delegacion = Object.create(DatabaseModel);

Delegacion.model = 'delegacion';
Delegacion.modelFront = 'delegaciones';

export default Delegacion;